function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .verPDF {\r\n        fill: currentColor;\r\n        stroke-width: 0px;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Ic2cHf.tif"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "verPDF",
  d: "M17.7,24.4H3.4c0,0-.1,0-.2-.1-1.3-.5-1.9-1.3-1.9-2.7,0-.3,0-.6,0-.9-1-.2-1.3-.4-1.3-1.1,0-2.1,0-4.2,0-6.3,0-.6.4-.9.9-1,.1,0,.2,0,.4,0,0-.2,0-.4,0-.5,0-3,0-5.9,0-8.9C1.3,1.1,2.4,0,4,0,7.1,0,10.2,0,13.3,0c.2,0,.5.1.6.2,1.9,1.9,3.8,3.7,5.6,5.6.2.2.3.4.3.6,0,1.6,0,3.2,0,4.7,0,3.5,0,6.9,0,10.4,0,1.3-.7,2.2-1.9,2.6,0,0-.1,0-.2,0ZM13.1,1.6c-.2,0-.3,0-.4,0-2.8,0-5.7,0-8.5,0-.9,0-1.3.3-1.3,1.3,0,3,0,5.9,0,8.9,0,.1,0,.3,0,.5.2,0,.4,0,.5,0,3.9,0,7.8,0,11.7,0,.9,0,1.3.4,1.3,1.3,0,1.9,0,3.8,0,5.8,0,1-.3,1.4-1.4,1.4-3.8,0-7.7,0-11.5,0-.2,0-.4,0-.6,0,0,.4,0,.7,0,.9,0,.9.4,1.2,1.2,1.2,4.3,0,8.6,0,12.9,0,.9,0,1.3-.4,1.3-1.2,0-4.7,0-9.5,0-14.2,0-.2,0-.3,0-.5-1,0-2,0-2.9,0-1.5,0-2.1-.7-2.1-2.1,0-1,0-2,0-3ZM6.5,14.3c0,1.4,0,2.8,0,4.1,0,0,.2.3.3.3.7,0,1.4,0,2-.1,1.1-.2,1.6-1.2,1.6-2.4,0-1-.7-1.7-1.8-1.9-.7,0-1.3,0-2.1,0ZM3.7,18.7v-1.4c.5-.1,1-.2,1.4-.3.6-.2.8-.8.8-1.4,0-.6-.4-1-1-1.1-.7-.2-1.4-.1-2.2,0v4.3h1ZM12.1,18.7v-1.8h1.5v-.8h-1.5v-1h1.6v-.8h-2.6v4.3h1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "verPDF",
  d: "M7.6,15.1v2.8c.7.1,1.2,0,1.5-.5.3-.5.3-1.4,0-1.8-.4-.5-.9-.6-1.5-.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "verPDF",
  d: "M3.8,16.4v-1.2c.3-.2.7-.2.9.1.1.2.2.5.1.7-.2.4-.6.4-1.1.4Z"
})));

var SvgPdf = function SvgPdf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 19.8 24.4",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PDF.8017cabe.svg";
export { ForwardRef as ReactComponent };